import { useState } from "react";
import Navigation from "components/Navigation";
import Footer from "components/Footer";
import {
  Divider,
  Heading,
  Container,
  Box,
  Stack,
  FormControl,
  FormLabel,
  Text,
  Input,
  Button,
  useToast,
} from "@chakra-ui/react";
import styles from "styles/Join.module.css";
import { supabase } from "utils/supabaseClient";
import { useRouter } from "next/router";
import { basePath } from "utils/siteConfig";

export default function () {
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const toast = useToast();

  const handleForm = async (event) => {
    event.preventDefault();
    setLoading(true);

    // const res = await fetch("/api/spotters", {
    //   body: JSON.stringify(data),
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   method: "POST",
    // });

    // const result = await res.json();

    const { error } = await supabase.auth.signIn(
      {
        email: event.target.email.value,
      },
      {
        redirectTo: `http://${basePath + "/spotter"}`,
      },
    );

    if (error != null) {
      toast({
        title: "Une erreur est survenue, réessayez plus tard.",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } else {
      router.push("/confirmation-spotter");
    }
    setLoading(false);
  };

  return (
    <>
      <Navigation darkImage transparent />
      <div className={styles.CloudDivider}></div>
      <div className={styles.Container}>
        <Container maxW="container.sm" alignItems={"center"}>
          <article>
            <Heading size={"2xl"}>Devenir Spotter</Heading>
            <Box
              bg={"white"}
              color={"black"}
              p={4}
              boxShadow={"2xl"}
              mt={6}
              borderRadius={"lg"}
            >
              <form onSubmit={handleForm}>
                <Stack spacing={4}>
                  <FormControl>
                    <FormLabel htmlFor="email">
                      Adresse email{" "}
                      <small>
                        <Text color="gray.500" display="inline">
                          (obligatoire)
                        </Text>
                      </small>
                    </FormLabel>
                    <Input
                      id="email"
                      name="email"
                      isRequired
                      type="email"
                      variant="filled"
                      placeholder="email@exemple.com"
                      colorScheme={"secondary"}
                      autoComplete="email"
                    />
                  </FormControl>
                  <Button
                    type="submit"
                    colorScheme={"brand"}
                    isLoading={loading}
                    width="full"
                  >
                    Rejoindre l'équipe
                  </Button>
                </Stack>
              </form>
            </Box>
          </article>
        </Container>
      </div>
      <Footer />
    </>
  );
}
